import { FC } from "react";

import SystemConfigurationContainer from "@app/containers/systemConfiguration";

const SystemConfigurationPage: FC = () => <SystemConfigurationContainer />;

export default SystemConfigurationPage;
